'use client'

// WorldEntities - debug markers for agent entities.
// Toggle DEBUG_MARKERS to show/hide the debug poles/spheres.

import { useMemo, memo } from 'react'
import useGameStore from '../../../stores/gameStore'
import { useStoreWithEqualityFn } from 'zustand/traditional'

// Debug-only ground rings showing where the sim thinks entities are. Off in
// the public view — unlabelled white rings around food/shrine/offerings just
// read as noise. Flip to true when debugging entity positions.
const DEBUG_MARKERS = false

const TYPE_COLORS = {
  FOOD_SPOT: '#facc15',
  NEST: '#3b82f6',
  SHINY: '#a78bfa',
}

function DebugMarker({ entity }) {
  const color = TYPE_COLORS[entity.type] || '#ffffff'
  return (
    <group position={[entity.pos.x, 0, entity.pos.z]}>
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.05, 0]}>
        <ringGeometry args={[1.2, 1.6, 16]} />
        <meshBasicMaterial color={color} transparent opacity={0.5} />
      </mesh>
    </group>
  )
}

const DebugMarkerMemo = memo(DebugMarker)

export function WorldEntities() {
  const entityStates = useStoreWithEqualityFn(
    useGameStore,
    (s) => s.entityStates,
    (prev, next) => prev.length === next.length &&
      prev.every((e, i) => e.id === next[i]?.id && e.pos.x === next[i]?.pos.x && e.pos.z === next[i]?.pos.z)
  )

  const { debugEntities } = useMemo(() => ({
    debugEntities: DEBUG_MARKERS ? entityStates : [],
  }), [entityStates])

  return (
    <group>
      {debugEntities.map(e => <DebugMarkerMemo key={e.id} entity={e} />)}
    </group>
  )
}
